import React, { FC } from 'react';
import Image from 'next/image';
import { Link } from '@/navigation';

import { Button } from '../Buttons';

import {
  TypeCollectionMarketingCardFields,
  TypeLink_internalFields,
} from '@/core/generated-types';
import classNames from 'classnames';
import { slugBuilder } from '@/core/contentfulConfig';
import { Entry } from 'contentful';

const CollectionMarketingCard: FC<TypeCollectionMarketingCardFields> = ({
  image,
  listedPage,
  title,
  description,
  buttonText,
  hideGradient,
  textColor = 'light',
}) => {
  const imageUrl = image.fields.file.url;

  const link = {
    fields: { linkContent: listedPage },
  } as Entry<TypeLink_internalFields>;

  const href = slugBuilder(link);

  return (
    <div className="relative mx-auto mb-8 max-w-[328px] md:max-w-[360px] bg-transparent shadow-lg hover:-translate-y-px hover:shadow-xl hover:transition">
      {!hideGradient && (
        <div
          data-testid="gradient"
          className="absolute z-[2] rounded-[5px] bg-gradient-to-t from-[#5E5E5E] via-transparent to-transparent w-full h-full"
        />
      )}
      <div className="absolute z-[1] rounded-[5px] w-full h-full">
        <Image
          alt={'product'}
          src={`https:${imageUrl}`}
          fill
          quality={90}
          style={{
            objectFit: 'cover',
            objectPosition: 'center top',
            borderRadius: '5px',
          }}
        />
      </div>
      <Link
        href={href}
        className="relative z-[3] h-[572px] mx-auto pb-10 flex w-full flex-col justify-end rounded-[5px]"
      >
        <div
          data-testid="card-container"
          className={classNames('flex flex-col px-8 pb-16 text-left', {
            'text-white': textColor === 'light',
            'text-charcoal-v2': textColor === 'dark',
          })}
        >
          <div
            className="flex-grow text-[24px] font-bold"
            data-testid="product-name"
          >
            {title}
          </div>
          <div
            className="mb-[14px] text-left text-base md:block mt-1"
            data-testid="product-description"
          >
            {description}
          </div>

          <Button
            ctaText={buttonText}
            classes="whitespace-nowrap text-base absolute bottom-10 left-8 !w-auto"
            fullWidth
          />
        </div>
      </Link>
    </div>
  );
};

export default React.memo(CollectionMarketingCard);
